import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/in-the-office-rafiki.svg'

interface Props {
  animate?: boolean
}

function CCTVPoliciesImage({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const containerClassName = containerRef.current.className
        .split(' ')
        .join('.')

      const animInstances: anime.AnimeInstance[] = []
      const animateConfig = {
        easing: 'easeInOutSine',
        direction: 'alternate',
        loop: true,
        duration: 1000,
        endDelay: 350,
      }

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #eye-r`,
          translateX: ['0.15%', '0%'],
          direction: 'normal',
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #eye-l`,
          translateX: ['0.3%', '0%'],
          direction: 'normal',
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #cctv`,
          transform: [
            {
              value:
                'matrix(0.999623,-0.0274532,0.0274532,0.999623,-0.437072,21.0673)',
              duration: 0,
              delay: 0,
              endDelay: 1000,
            },
            {
              value:
                'matrix(0.999623,-0.0274532,0.0274532,0.999623,-10.2718,28.1222)',
              duration: 1000,
              delay: 350,
            },
            {
              value:
                'matrix(0.965191,-0.261546,0.261546,0.965191,-4.25517,151.086)',
              duration: 1000,
              delay: 350,
              endDelay: 1000,
            },
          ],
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #cctv-neck`,
          transform: [
            {
              value: 'matrix(1,0,0,1,0,7.68655)',
              duration: 0,
              delay: 0,
              endDelay: 1000,
            },
            {
              value:
                'matrix(0.914738,-0.404047,0.404047,0.914738,17.0301,219.618)',
              duration: 1000,
              delay: 350,
            },
            {
              value:
                'matrix(0.914738,-0.404047,0.404047,0.914738,17.0301,219.618)',
              duration: 1000,
              delay: 350,
              endDelay: 1000,
            },
          ],
        }),
      )

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box ref={containerRef}>
      <Image />
    </Box>
  )
}
export default CCTVPoliciesImage
